import { render, staticRenderFns } from "./card-table.vue?vue&type=template&id=397e991b&scoped=true&"
import script from "./card-table.vue?vue&type=script&lang=js&"
export * from "./card-table.vue?vue&type=script&lang=js&"
import style0 from "./card-table.vue?vue&type=style&index=0&id=397e991b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e991b",
  null
  
)

export default component.exports